import { useRef } from 'react';
import { ArrowDown, ArrowUpRight, Asterisk, MapPin } from 'lucide-react';
import { motion as Motion, useScroll, useTransform } from 'motion/react';
import { useApp } from '../../context/AppContext';

// The opening scene pairs editorial typography with theme-aware portrait art.
export function Hero() {
  const { t, theme } = useApp();
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: sectionRef, offset: ['start start', 'end start'] });
  const imageY = useTransform(scrollYProgress, [0, 1], [0, 95]);
  const textY = useTransform(scrollYProgress, [0, 1], [0, -45]);

  return (
    <section ref={sectionRef} className="hero page-shell" aria-labelledby="hero-title">
      <div className="hero-grid-lines" aria-hidden="true" />

      <Motion.div className="hero-copy" style={{ y: textY }}>
        <div className="availability-pill">
          <span className="availability-pulse" />
          {t.hero.availability}
        </div>

        <p className="hero-eyebrow"><Asterisk size={15} /> {t.hero.eyebrow}</p>
        <h1 id="hero-title">
          <span>{t.hero.line1}</span>
          <span>{t.hero.line2}</span>
          <span className="hero-title-accent">{t.hero.line3}</span>
        </h1>
        <p className="hero-summary">{t.hero.summary}</p>

        <div className="hero-actions">
          <a className="button button--primary" href="#work">
            {t.hero.ctaWork}<ArrowDown size={17} />
          </a>
          <a className="button button--ghost" href="#contact">
            {t.hero.ctaContact}<ArrowUpRight size={17} />
          </a>
        </div>

        <p className="hero-location"><MapPin size={14} /> {t.hero.location}</p>
      </Motion.div>

      <Motion.div className="portrait-stage" style={{ y: imageY }}>
        <div className="portrait-index" aria-hidden="true">01<span>/</span>05</div>
        <div className="portrait-orbit portrait-orbit--one" aria-hidden="true" />
        <div className="portrait-orbit portrait-orbit--two" aria-hidden="true" />
        <div className="portrait-frame">
          <img
            src={theme === 'dark' ? '/images/afshin-dark.jpg' : '/images/afshin-light.png'}
            alt="Afshin Zehtab, full-stack web developer and digital designer"
            width="1024"
            height="1024"
            fetchPriority="high"
          />
          <div className="portrait-caption" aria-hidden="true">
            <span>AFSHIN ZEHTAB</span>
          </div>
        </div>
        <div className="portrait-stamp" aria-hidden="true">
          <svg viewBox="0 0 120 120">
            <defs><path id="stampPath" d="M60,60 m-43,0 a43,43 0 1,1 86,0 a43,43 0 1,1 -86,0" /></defs>
            <text><textPath href="#stampPath">DESIGN · DEVELOP · DELIVER · </textPath></text>
          </svg>
          <Asterisk size={22} />
        </div>
      </Motion.div>

      <a className="scroll-cue" href="#about">
        <span>{t.hero.scroll}</span><ArrowDown size={14} />
      </a>
    </section>
  );
}
